import React, {useCallback} from 'react'
import {ButtonLink, TrashBinIcon} from '@modifi/ui'

type DeleteLegalRepresentativeButtonProps = {
  onClick: () => void
  externalPersonId: string
}

const DeleteLegalRepresentativeButton: React.FC<DeleteLegalRepresentativeButtonProps> = ({
  onClick,
  externalPersonId,
}) => {
  const handleClick = useCallback(
    (e: React.UIEvent) => {
      e.preventDefault()
      onClick()
    },
    [onClick]
  )

  return (
    <ButtonLink
      onClick={handleClick}
      iconOnly
      transparent
      type="button"
      data-target="open-delete-legal-representative-dialog"
      data-external-id={externalPersonId}
    >
      <TrashBinIcon />
    </ButtonLink>
  )
}

export default DeleteLegalRepresentativeButton
